import type { MediaItem } from '@/sections/products/product.types'

/**
 * ดึงรูปภาพแรกจาก mediaUrls
 * @param mediaUrls - array ของ media items
 * @returns URL ของรูปภาพแรก หรือ null ถ้าไม่มีรูปภาพ
 */
export function getFirstImageMedia(mediaUrls: MediaItem[]): string | null {
  if (!mediaUrls || mediaUrls.length === 0) {
    return null
  }

  // หารูปภาพแรก (type === 'image')
  const firstImage = mediaUrls.find((media) => media.type === 'image')

  if (firstImage) {
    return firstImage.url
  }

  // ถ้าไม่มีรูปภาพ return null
  return null
}

/**
 * ดึงรูปภาพตาม index
 * @param mediaUrls - array ของ media items
 * @param index - index ของรูปภาพที่ต้องการ
 * @returns URL ของรูปภาพตาม index หรือ null
 */
export function getImageMediaByIndex(
  mediaUrls: MediaItem[],
  index: number,
): string | null {
  if (
    !mediaUrls ||
    mediaUrls.length === 0 ||
    index < 0 ||
    index >= mediaUrls.length
  ) {
    return null
  }

  const media = mediaUrls[index]
  return media?.url || null
}

/**
 * ดึงรูปภาพทั้งหมด (เฉพาะ type === 'image')
 * @param mediaUrls - array ของ media items
 * @returns array ของ URL รูปภาพ
 */
export function getAllImageMedia(mediaUrls: MediaItem[]): string[] {
  if (!mediaUrls || mediaUrls.length === 0) {
    return []
  }

  return mediaUrls
    .filter((media) => media.type === 'image')
    .map((media) => media.url)
}
